/**
 * Schema constants and helpers for working with the list origin + tags model.
 * Mirrors the backend ProfileKindSlug constants verbatim.
 */

/** Profile-kind tag slugs. Use these instead of the old list_type strings. */
export const PROFILE_KIND = {
  TOP5_ALLTIME: "top5-alltime",
  STANDOUTS:    "standouts",
};

/**
 * Return the profile-kind slug for a list (e.g. "top5-alltime"), or null
 * if the list is not a PROFILE-origin list.
 */
export function getProfileKind(list) {
  if (!list || list.origin !== "profile") return null;
  const tag = list.tags?.find((t) => t.kind === "profile-kind");
  return tag?.slug ?? null;
}

/**
 * Return true for a yearly standouts list — the one profile list that opens in
 * the collection dialog (read-only, shareable, never saveable).
 */
export function isStandoutsList(list) {
  return getProfileKind(list) === PROFILE_KIND.STANDOUTS;
}

/** Return true if the list was created by a user (not canonical or profile). */
export function isUserOriginList(list) {
  return list?.origin === "user";
}
